module.exports = __webpack_public_path__ + "img/icon-close.e8ba5409.svg";